import { doc, getDoc, collection, query, where, getDocs, getFirestore } from 'firebase/firestore';
import firebaseApp from '../../firebase/credenciales';

const db = getFirestore(firebaseApp);

/**
 * Genera el archivo de Pagos Masivos BCP (Formato Telecrédito - Haberes)
 * Incluye registro de cabecera y detalle.
 */
export const generarPagosBCP = async (planillaId) => {
  try {
    const planillaRef = doc(db, "pl_planillas", planillaId);
    const planillaDoc = await getDoc(planillaRef);
    if (!planillaDoc.exists()) throw new Error("Planilla no encontrada");
    const planilla = planillaDoc.data();

    const detalleQuery = query(
      collection(db, "pl_planilla_detalle"),
      where("planilla_id", "==", planillaId)
    );
    const detalleSnapshot = await getDocs(detalleQuery);
    const detalles = [];
    detalleSnapshot.forEach(doc => detalles.push(doc.data()));

    if (detalles.length === 0) throw new Error("No hay trabajadores en esta planilla");

    // Registro de Cabecera (Tipo 'A')
    const totalNeto = detalles.reduce((sum, d) => sum + Number(d.neto_pagar || 0), 0);
    const numTrabajadores = detalles.length;
    
    // Simplificación del formato BCP Telecrédito para este ejemplo
    // Formato estándar suele ser: 
    // Tipo(1) + Cuenta(20) + Moneda(4) + Monto(15) + Referencia(40) + ...
    const cuentaEmpresa = "191-00000000-0-00".padEnd(20, ' '); // Placeholder
    const montoTotalStr = totalNeto.toFixed(2).replace('.', '').padStart(15, '0');
    
    const cabecera = `A${cuentaEmpresa}S001${montoTotalStr}${(planilla.periodo || '').padEnd(40, ' ')}`;

    // Registros de Detalle (Tipo '1' o 'D' según versión)
    const lineasDetalle = detalles.map(d => {
      const tipoCta = 'S'; // Soles
      const numCta = String(d.numero_cuenta || '').padEnd(20, ' ');
      const nombre = `${d.apellidos || ''} ${d.nombres || ''}`.trim().substring(0, 40).padEnd(40, ' ');
      const monto = Number(d.neto_pagar || 0).toFixed(2).replace('.', '').padStart(15, '0');
      const dni = String(d.dni || '').padStart(12, '0');

      return `1${numCta}${nombre}${monto}${dni}`;
    });

    const contenido = [cabecera, ...lineasDetalle].join('\r\n') + '\r\n';
    const nombreArchivo = `BCP_PAGOS_${planilla.periodo || 'MARZO_2026'}.txt`;
    
    descargarArchivo(nombreArchivo, contenido);

    return { 
      success: true, 
      message: `Archivo BCP Telecrédito generado (${numTrabajadores} registros)` 
    };
  } catch (error) {
    console.error("Error generando pagos BCP:", error);
    throw error;
  }
};

const descargarArchivo = (nombre, contenido) => {
  const blob = new Blob([contenido], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
